import TwoCalendarContainer2 from "./twoCalendarContainer2";
import XBtn4 from "./xBtn4";

export default function WhenPopUpLaptop() {
  return (
    <div className=" bg-white mt-4 w-full max-w-c850 rounded-3xl zmax px-12 pt-10 pb-10 relative box-shadow-u13  ">
      <TwoCalendarContainer2 />
      <XBtn4 />
    </div>
  );
}
